import { getApp, getApps, initializeApp } from 'firebase/app';
import {
  GoogleAuthProvider,
  connectAuthEmulator,
  createUserWithEmailAndPassword,
  getAuth,
  isSignInWithEmailLink,
  sendPasswordResetEmail,
  signInWithEmailLink,
  signInWithPopup,
  signInWithEmailAndPassword,
  signOut,
  updatePassword,
} from 'firebase/auth';

import {
  FIREBASE_CONFIG,
  FIREBASE_EMULATOR_URL,
  IS_DEV,
} from '@/lib/constants';

const app = getApps().length > 0 ? getApp() : initializeApp(FIREBASE_CONFIG);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

if (IS_DEV) {
  connectAuthEmulator(auth, FIREBASE_EMULATOR_URL, { disableWarnings: true });
}

export {
  app,
  auth,
  createUserWithEmailAndPassword,
  googleProvider,
  isSignInWithEmailLink,
  sendPasswordResetEmail,
  signInWithEmailLink,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
  updatePassword,
};
